import { Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import * as Yup from 'yup';
import PlansState from '../Context/state';

const ModalCreatePlanPrice = ({ planDialog, hideDialog }) => {
    const { CreatePlan, plans } = PlansState();

    const UserSchema = Yup.object().shape({
        price: Yup.number().required('Campo Obrigatório'),
        time: Yup.number().required('Campo Obrigatório')
    });

    return (
        <Dialog visible={planDialog} style={{ width: '450px' }} header="Criar Plano" modal className="p-fluid" onHide={hideDialog}>
            <Formik
                validationSchema={UserSchema}
                initialValues={{ price: 0, time: 0 }}
                onSubmit={(values) => {
                    CreatePlan({ ...values, plan: plans.id }, hideDialog);
                }}
            >
                {({ values, handleChange, errors, touched, handleSubmit }) => {
                    return (
                        <Form onSubmit={handleSubmit}>
                            <div className="field">
                                <label htmlFor="name">Preço</label>
                                <InputNumber
                                    mode="currency"
                                    currency="BRL"
                                    locale="pt-BR"
                                    name="price"
                                    id="price"
                                    value={values?.price}
                                    onValueChange={handleChange}
                                    required
                                    autoFocus
                                    className={classNames({ 'p-invalid': errors.price && touched.price })}
                                />
                                {errors.price && touched.price && <small className="p-invalid">{errors.price}</small>}
                            </div>
                            <div className="field">
                                <label htmlFor="name">Tempo em dias</label>
                                <InputNumber showButtons name="time" id="time" value={values?.time} onValueChange={handleChange} required autoFocus className={classNames({ 'p-invalid': errors.time && touched.time })} />
                                {errors.time && touched.time && <small className="p-invalid">{errors.time}</small>}
                            </div>

                            <div className="p-5"></div>
                            <div className="flex align-items-center justify-content-end">
                                <div className=" w-6 flex align-items-center justify-content-end">
                                    <Button label="Cancel" type="button" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                                    <Button label="Save" type="submit" icon="pi pi-check" className="p-button-text" />
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

export default ModalCreatePlanPrice;
